/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SchemasSystemSimResultData } from './SchemasSystemSimResultData';
import {
    SchemasSystemSimResultDataFromJSON,
    SchemasSystemSimResultDataFromJSONTyped,
    SchemasSystemSimResultDataToJSON,
    SchemasSystemSimResultDataToJSONTyped,
} from './SchemasSystemSimResultData';

/**
 * 観測所ごとのsim_result
 * @export
 * @interface AllResultsStationSimResult
 */
export interface AllResultsStationSimResult {
    /**
     * 観測所ID
     * @type {string}
     * @memberof AllResultsStationSimResult
     */
    id: string;
    /**
     * シミュレーション結果データ
     * @type {Array<SchemasSystemSimResultData>}
     * @memberof AllResultsStationSimResult
     */
    simResult: Array<SchemasSystemSimResultData>;
}

/**
 * Check if a given object implements the AllResultsStationSimResult interface.
 */
export function instanceOfAllResultsStationSimResult(value: object): value is AllResultsStationSimResult {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('simResult' in value) || value['simResult'] === undefined) return false;
    return true;
}

export function AllResultsStationSimResultFromJSON(json: any): AllResultsStationSimResult {
    return AllResultsStationSimResultFromJSONTyped(json, false);
}

export function AllResultsStationSimResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): AllResultsStationSimResult {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'simResult': ((json['sim_result'] as Array<any>).map(SchemasSystemSimResultDataFromJSON)),
    };
}

export function AllResultsStationSimResultToJSON(json: any): AllResultsStationSimResult {
    return AllResultsStationSimResultToJSONTyped(json, false);
}

export function AllResultsStationSimResultToJSONTyped(value?: AllResultsStationSimResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'sim_result': ((value['simResult'] as Array<any>).map(SchemasSystemSimResultDataToJSON)),
    };
}

